// extracted by mini-css-extract-plugin
export default {"root":"JJcNY1","form-container":"vB4g7U","formContainer":"vB4g7U","error-container":"KKHyG_","errorContainer":"KKHyG_"};